import React from "react";
import { Grid } from "@mui/material";
import { exportView } from "../../navigation";
import { PortfolioTabNavigation } from "../dashboards/dashboard-portfolio/portfolio-space";

const SearchPortfolio = () => (
	<Grid>
		<PortfolioTabNavigation search />
	</Grid>
);

export default exportView({
	path: "/portfolio/search-multiple",
	localesPath: "/my-review/locales",
	component: SearchPortfolio,
});
